import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=4942faf7&scoped=true&"
import script from "./DetailsTable.vue?vue&type=script&lang=ts&"
export * from "./DetailsTable.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&id=4942faf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942faf7",
  null
  
)

export default component.exports